import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "header",
  class: "bc-6 c-sub-6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header-bar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-bar-inner" })
], -1)
const _hoisted_3 = { class: "header-inner" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "main" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sub hide-sp" }, null, -1)
const _hoisted_7 = { class: "information hide-sp" }
const _hoisted_8 = { class: "header-icons" }
const _hoisted_9 = { class: "clock" }
const _hoisted_10 = { class: "hide-pc" }

import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import Menu from '@/components/common/Menu.vue'
import Clock from '@/components/common/Clock.vue'
import { usePopup } from '@/components/common/Popup'
import { useGlobalStore } from '@/stores/globalStore'
import { useInitDataStore } from '@/stores/initDataStore'
import { useNewsHistoryStore } from '@/stores/newsStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isOpenMenu = ref(false)
const showSpClock = ref(true)

const globalStore = useGlobalStore()
const initDataStore = useInitDataStore()
const newsStore = useNewsHistoryStore()

const closeMenu = () => {
  isOpenMenu.value = false
}

const openMenu = () => {
  isOpenMenu.value = true
}

const route = useRoute()
globalStore.subTitle = route.name as string

const handleChangeRoute = () => {
  // ページ遷移後にメニューを閉じる
  isOpenMenu.value = false

  if (route.path !== '/reports') {
    globalStore.subTitle = route.name as string
  }

  // SP用Clockの表示制御(Topだけ表示)
  showSpClock.value = route.path === '/'
}

const cautionActive = computed(() => {
  return newsStore.has10DaysNews()
})

const logoStyle = computed(() => {
  const imgPath = initDataStore.initData.systemInfo.logo

  if (!imgPath) {
    return {}
  }

  const cacheClearKey = new Date().getTime()
  const logoImgPath = `${imgPath}?${cacheClearKey}`

  return { backgroundImage: `url(${logoImgPath})` }
})

const { toggle: togglePopup } = usePopup()

handleChangeRoute()
watch(() => route.path, handleChangeRoute)
watch(() => route.query, handleChangeRoute)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo-link"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            style: _normalizeStyle(_unref(logoStyle)),
            class: "logo"
          }, null, 4)
        ]),
        _: 1
      }),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(initDataStore).initData.systemInfo.title), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(togglePopup) && _unref(togglePopup)(...args))),
              class: _normalizeClass([_unref(cautionActive) && 'active', "btn header-icons-item header-icons-item-caution2"])
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Clock)
          ]),
          _createElementVNode("div", {
            onClick: openMenu,
            class: "btn-menu bc-1"
          })
        ])
      ]),
      _createVNode(Menu, {
        onClose: closeMenu,
        isOpen: isOpenMenu.value,
        class: "hide-sp"
      }, null, 8, ["isOpen"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (showSpClock.value)
        ? (_openBlock(), _createBlock(Clock, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})